export const formatNumber = (value) =>
  value == null || value === "" || !Number.isFinite(Number(value))
    ? "—"
    : new Intl.NumberFormat("en-NP", { maximumFractionDigits: 2 }).format(
        Number(value)
      );
export const formatCurrency = (value) =>
  value == null || value === "" || !Number.isFinite(Number(value))
    ? "—"
    : `Rs ${new Intl.NumberFormat("en-NP", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(Number(value))}`;
export const formatDate = (value, withTime = false) => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  const day = new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  }).format(date);
  return withTime
    ? `${day} • ${new Intl.DateTimeFormat("en-US", {
        hour: "numeric",
        minute: "2-digit",
      }).format(date)}`
    : day;
};
